import React from 'react';
import { TrumpDeclarationHudProps } from '../../games/common/GameComponentContracts';
import { DeclareTrumpHud } from './DeclareTrumpHud';
import { DeclareNoTrumpHud } from './DeclareNoTrumpHud';

/**
 * Game-specific Trump & No-Trump declaration HUD for Bid Whist.
 */
export const BidWhistTrumpDeclarationHud: React.FC<TrumpDeclarationHudProps> = ({
  gameState,
  turnTimerSeconds,
  turnTimerMax = 20,
  onDeclareTrumpSuit,
  onDeclareNoTrumpDirection
}) => {
  const declareTimerMax = turnTimerMax && turnTimerMax <= 20 ? turnTimerMax : 20;

  if (gameState.isNoTrump) {
    return (
      <DeclareNoTrumpHud
        key={`declare_nt_hud_${gameState.handNumber}`}
        winningBid={gameState.winningBid || 4}
        turnTimerSeconds={turnTimerSeconds}
        turnTimerMax={declareTimerMax}
        onSelectDirection={(dir) => {
          if (onDeclareNoTrumpDirection) {
            onDeclareNoTrumpDirection(dir);
          } else {
            onDeclareTrumpSuit('NoTrump');
          }
        }}
      />
    );
  }

  return (
    <DeclareTrumpHud
      key={`declare_trump_hud_${gameState.handNumber}`}
      winningBid={gameState.winningBid || 4}
      direction={gameState.direction || 'UP'}
      turnTimerSeconds={turnTimerSeconds}
      turnTimerMax={declareTimerMax}
      onSelectTrumpSuit={onDeclareTrumpSuit}
    />
  );
};
